export const CLASS_NAMES = {
  baseContent: "flex flex-row relative item-center",
};
